import { createContext, useState, useEffect, useCallback } from 'react'
import { ITenant } from '../pages/AbmLocalPage/types'
import Loading from '../components/Common/Loading'
import { getTenant, getTenants } from '../pages/Products/services/admin.services'
import { useDispatch } from 'react-redux'
import { defaultTenant } from '../redux/reducers/tenant'

interface TenantsContextProps {
  tenant: ITenant
  setTenant: (tenant: ITenant) => void
  loading: boolean
  fetchTenants: () => Promise<void>
  tenants: ITenant[]
  domain: string
}

export const TenantsContext = createContext<TenantsContextProps>({
  tenant: defaultTenant,
  setTenant: () => {},
  loading: false,
  fetchTenants: async () => {},
  tenants: [],
  domain: ''
})

const getDomain = () => {
  const hostname = window.location.hostname
  if (hostname?.includes('localhost')) {
    const params = new URL(window.location as any).searchParams
    const tenant = params.get('dominio')
    return tenant || defaultTenant.dominios
  } else {
    const parts = hostname.split('.')
    const domain = parts.slice(-2).join('.')
    return domain
  }
}

export const TenantsProvider = ({ children }: any) => {
  const [domain, setDomain] = useState<string>()
  const [tenant, setTenant] = useState<ITenant>(() => {
    // recupero del localStorage
    const saved = localStorage.getItem('tenant')
    return saved ? JSON.parse(saved) : defaultTenant
  })
  const [tenants, setTenants] = useState<ITenant[]>([])
  const [loading, setLoading] = useState<boolean>(true)
  const dispatch = useDispatch()

  const fetchDataTenancy = useCallback(async () => {
    try {
      await getTenant(domain).then(({ data }) => {
        setTenant(data.data)
        dispatch({
          type: 'setTenant',
          payload: data.data // actualiza Redux
        })
      })
    } catch (e) {
      console.log(e)
    } finally {
      setLoading(false)
    }
  }, [domain])

  useEffect(() => setDomain(getDomain), [])

  const fetchTenants = useCallback(async () => {
    try {
      setLoading(true)
      const res = await getTenants()
      setTenants(res.data.data)
    } catch (e) {
      console.log(e)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    if (!domain) return
    fetchDataTenancy()
  }, [domain])

  if (!tenant || loading) return <Loading />
  if (!tenant?.path || tenant?.path === '') return null

  return (
    <TenantsContext.Provider
      value={{
        setTenant,
        tenant,
        loading,
        fetchTenants,
        tenants,
        domain
      }}
    >
      {children}
    </TenantsContext.Provider>
  )
}
